import { initAllBrandSwipers } from './init-brand-swiper';

function boot() {
	initAllBrandSwipers();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
